/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Action_LabelInputs */

const en_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Markers`)
};

const fr_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer les marqueurs`)
};

const de_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importmarkierungen`)
};

const it_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa marcatori`)
};

const ru_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортные марки`)
};

const es_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de importación`)
};

const zh_cn2_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入标记`)
};

const ja_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーをインポート`)
};

const hi_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात मार्कर`)
};

const pt_pt2_marker_import_action_label = /** @type {(inputs: Marker_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de Importação`)
};

/**
* | output |
* | --- |
* | "Import Markers" |
*
* @param {Marker_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_action_label = /** @type {((inputs?: Marker_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_action_label(inputs)
	if (locale === "de") return de_marker_import_action_label(inputs)
	if (locale === "it") return it_marker_import_action_label(inputs)
	if (locale === "ru") return ru_marker_import_action_label(inputs)
	if (locale === "es") return es_marker_import_action_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_action_label(inputs)
	if (locale === "ja") return ja_marker_import_action_label(inputs)
	if (locale === "hi") return hi_marker_import_action_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_action_label(inputs)
	return en_marker_import_action_label(inputs)
});